<template>
    <router-link v-if="to" :to="to" v-on="$listeners" class="app-button">
        <span v-if="$slots.icon" class="app-button__icon">
            <slot name="icon"/>
        </span>
        <slot/>
    </router-link>
    <a v-else :href="href" v-on="$listeners" :target="target" class="app-button">
        <span v-if="$slots.icon" class="app-button__icon">
            <slot name="icon"/>
        </span>
        <slot/>
    </a>
</template>

<script>
    export default {
        name: "AppButton",
        props: {
            to: {
                type: [String, Object],
                default: null
            },
            href: {
                type: String,
                default: 'javascript:;'
            },
            target:{
                type: String,
                default:'_self'
            }
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-button {
        color: $secondaryTextColor;
        color: var(--secondaryTextColor);
        @include transition-colors;


        &[disabled] {
            opacity: .3;
        }

        .app-icon {
            @include transition-colors;
        }

        &:hover {
            color: $primaryColor;
            color: var(--primaryColor);

            .app-icon {
                color: $primaryColor;
                color: var(--primaryColor);
            }
        }

        &__icon {
            display: inline-block;
            margin-right: $paddingSM;
        }
    }
</style>